import { shopifyFetch } from './client';
import {CREATE_CART, ADD_TO_CART, REMOVE_FROM_CART, UPDATE_CART_QUANTITY} from './queries';
import { SET_CART, SET_CART_LOADING, SET_CART_ERROR, CLEAR_CART, SET_TOAST } from '../stores/cart';

// Helper: map Shopify cart response → flat lines array
const mapLines = (cart) =>
    cart.lines.edges.map(({ node }) => ({
        lineId: node.id,
        variantId: node.merchandise.id,
        title: node.merchandise.product.title,
        variantTitle: node.merchandise.title,
        price: parseFloat(node.merchandise.priceV2.amount).toFixed(2),
        currency: node.merchandise.priceV2.currencyCode,
        image: node.merchandise.image?.url || null,
        quantity: node.quantity,
    }));

export const addToCart = (variantId) => async (dispatch, getState) => {
    dispatch(SET_CART_LOADING(true));
    dispatch(SET_CART_ERROR(null));

    const { cartId } = getState().cart;

    try {
        let cart;

        if (!cartId) {
            const res = await shopifyFetch(CREATE_CART, {
                lines: [{ merchandiseId: variantId, quantity: 1 }],
            });
            cart = res.data.cartCreate.cart;
        } else {
            const res = await shopifyFetch(ADD_TO_CART, {
                cartId,
                lines: [{ merchandiseId: variantId, quantity: 1 }],
            });
            cart = res.data.cartLinesAdd.cart;
        }

        dispatch(SET_CART({
            cartId: cart.id,
            checkoutUrl: cart.checkoutUrl,
            lines: mapLines(cart),
        }));

        // 👇 success toast
        dispatch(SET_TOAST({ message: 'Item added to cart!', type: 'success' }));

    } catch (err) {
        dispatch(SET_CART_ERROR(err.message));
        // 👇 error toast
        dispatch(SET_TOAST({ message: 'Failed to add item. Try again.', type: 'error' }));
    } finally {
        dispatch(SET_CART_LOADING(false));
    }
};

export const removeFromCart = (lineId) => async (dispatch, getState) => {
    dispatch(SET_CART_LOADING(true));

    const { cartId } = getState().cart;

    try {
        const res = await shopifyFetch(REMOVE_FROM_CART, {
            cartId,
            lineIds: [lineId],
        });
        const cart = res.data.cartLinesRemove.cart;

        dispatch(SET_CART({
            cartId: cart.id,
            checkoutUrl: cart.checkoutUrl,
            lines: mapLines(cart),
        }));
    } catch (err) {
        dispatch(SET_CART_ERROR(err.message));
    } finally {
        dispatch(SET_CART_LOADING(false));
    }
};

export const updateCartQuantity = (lineId, quantity) => async (dispatch, getState) => {
    dispatch(SET_CART_LOADING(true));
    const { cartId } = getState().cart;

    try {
        const res = await shopifyFetch(UPDATE_CART_QUANTITY, {
            cartId,
            lines: [{ id: lineId, quantity }],
        });
        const cart = res.data.cartLinesUpdate.cart;
        dispatch(SET_CART({
            cartId: cart.id,
            checkoutUrl: cart.checkoutUrl,
            lines: mapLines(cart),
        }));
    } catch (err) {
        dispatch(SET_CART_ERROR(err.message));
    } finally {
        dispatch(SET_CART_LOADING(false));
    }
};
